module.exports = __webpack_public_path__ + "static/media/camera.eeb71335.svg";